export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Copiado!",
    copy: "Copiar",
    edit: "Editar",
    remove: "Remover",
    addLink: "Link da OTA",
    modalEyebrow: "Link do anúncio na OTA",
    modalEyebrowUnit: "Link desta unidade na OTA",
    editTitle: "Editar link",
    addTitle: "Adicionar link da OTA",
    modalHint: "Cole a URL pública <b>deste anúncio</b> na OTA. Isso permite copiá-la e abri-la rapidamente.",
    urlLabel: "URL do anúncio",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar link",
    saveError: "Não foi possível salvar o link. Verifique a URL.",
    fromListing: "do anúncio",
    inheritedNote: "É o link do anúncio. Enquanto esta unidade não tiver o seu, é este que enviamos.",
    override: "Definir o seu",
    modalHintUnit: "Cole o URL público <b>desta unidade</b> na OTA. Se o definir, enviamos este; se o deixar vazio, enviamos o do anúncio.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Simule a jornada do hóspede",
    badge: "Teste",
    intro: "Reproduza todo o processo —da reserva à avaliação— em uma conversa do WhatsApp. Informe um nome e um número e clique em <strong>play</strong>. Se você ativar «Enviar para o celular», cada mensagem é realmente enviada ao número para que você possa testar e conversar com o Agente de IA.",
    guestNameLabel: "Nome do hóspede",
    guestNamePlaceholder: "ex.: Laura García",
    phoneLabel: "Número do WhatsApp (para teste)",
    phoneHint: "Formato internacional, ex.: +34 600123456",
    toggleTitle: "Também enviar para o celular",
    toggleDesc: "Cada etapa é realmente enviada para o número acima",
    warn: "Primeiro envie «oi» para o número pelo seu celular para abrir a janela de 24h do WhatsApp; assim você receberá as mensagens instantaneamente.",
    reset: "Reiniciar",
    prev: "Anterior",
    pause: "Pausar",
    play: "Play",
    continue: "Continuar",
    next: "Próximo",
    stepProgress: "Etapa {current} de {total}",
    guestFallback: "Hóspede",
    propertyFallback: "sua acomodação",
    testNumberFallback: "número de teste",
    dayLabel: "Jornada do hóspede",
    loadingMsgs: "Carregando suas mensagens…",
    pressPlay: "Pressione <strong>Play</strong> para iniciar a jornada ▶",
    hintSending: "Envio ao vivo ativado · cada etapa chega a {phone}",
    hintSimulated: "Visualização simulada · ative «Enviar para o celular» para testar em um telefone real",
    toastInvalidPhone: "Digite um número de WhatsApp válido para enviar ao celular.",
    toastSendFailed: "Não foi possível enviar.",
    toastSendMobileFailed: "Não foi possível enviar ao celular.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Olá *{{nombre_huesped}}* 👋\n\nSua reserva em *{{nombre_alojamiento}}* está confirmada ✅\n\nCódigo da reserva: *6233Q1VC5*\nDatas: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nPor este WhatsApp você pode solicitar o link do seu check-in online e receber as instruções de chegada.",
    msgCheckinPrompt: "*Olá* 👋 Sou o assistente virtual de *{{nombre_alojamiento}}*.\n\nPressione *Ok* para continuar com o seu check-in.",
    msgChooseLanguage: "Escolha seu idioma · Choose your language",
    msgCheckinLink: "*Obrigado* 👋 Aqui está o seu link para fazer o check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Bem-vindo a *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nObrigado por concluir seu cadastro. Aqui estão todas as informações sobre a sua estadia.",
    msgAccess: "🔒🔑 *Código de acesso · {{nombre_alojamiento}}*\n\nO seu código é: *58117*\n\nVálido durante toda a sua estadia.",
    msgArrival: "🏡 *Instruções de chegada*\n\nAo chegar, dirija-se à entrada principal e digite o seu código na fechadura. 🔑\n\nAproveite a sua estadia! ✨",
    msgGuestCheckout: "Olá, que horas é o check-out?",
    msgCheckoutReply: "Olá! O check-out é até *12:00* 🕚 Se você precisar sair mais tarde, posso verificar um late check-out para você 😊",
    msgCheckout: "Olá *{{nombre_huesped}}* 👋\n\nApenas um lembrete de que *sua estadia termina amanhã* em *{{nombre_alojamiento}}*.\n\n🕚 O horário limite de check-out é *{{hora_salida}}*.\n\nMuito obrigado pela sua visita e boa viagem! 😊",
    msgReview: "⭐ Como foi a sua estadia em *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nAdoraríamos saber a sua opinião. Deixe a sua avaliação aqui 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Jornada do hóspede",
    subtitle: "Da reserva à saída. Passe o mouse sobre cada evento para ver a mensagem.",
    disabled: "Desativado",
    clickToConfigure: "Clique para configurar",
    nameFallback: "sua acomodação",
    // Node labels
    labelLead: "Reserva / Lead",
    labelConfirm: "Confirmação",
    labelCheckinLink: "Link de check-in",
    labelWelcome: "Boas-vindas",
    labelAccess: "Acesso / Fechadura",
    labelArrival: "Instruções de chegada",
    labelCheckout: "Mensagem de saída",
    labelReview: "Avaliação",
    // Timing of each node
    whenLead: "Ao reservar ou enviar mensagem",
    whenConfirm: "Reserva confirmada",
    whenCheckinLink: "Antes da chegada",
    whenWelcome: "Após o cadastro",
    whenAccess: "Dia da chegada",
    whenArrival: "Dia da chegada",
    whenCheckout: "Véspera do check-out",
    whenReview: "Após o check-out",
    // WhatsApp previews
    previewLead: "👋 Olá! Sou o assistente virtual de *{name}*.\n\nEstou aqui para ajudar com a sua reserva e responder a qualquer dúvida.",
    previewConfirm: "Olá *Laura García* 👋\n\nSua reserva em *{name}* está confirmada ✅\n\nCódigo da reserva: *6233Q1VC5*\nDatas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp você pode solicitar o link do seu check-in online e também receber as instruções de chegada.\nSe precisar de ajuda antes ou durante a sua estadia, mande uma mensagem aqui 💬",
    previewWelcome: "👋 Bem-vindo a *{name}*!\n\nObrigado por concluir seu cadastro. Aqui estão todas as informações sobre a sua estadia.",
    previewAccess: "🔒🔑 *Código de acesso · {name}*\n\nO seu código é: *58117*\n\nVálido durante toda a sua estadia.",
    previewArrival: "🏡 *Instruções de chegada*\n\nAo chegar, dirija-se à entrada principal da acomodação. 🔑\n\nAproveite a sua estadia! ✨",
    previewCheckout: "Olá 👋\n\nApenas um lembrete de que *sua estadia termina amanhã* em *{name}*.\n\n🕚 O horário limite de check-out é *12:00*.\n\nBoa viagem! 😊",
    previewReview: "⭐ Como foi a sua estadia em *{name}*?\n\nAdoraríamos saber a sua opinião. Deixe a sua avaliação aqui 👉 …",
    previewLeadNoWaba: "📲 *Ative o seu Agente de IA* para atender novas reservas pelo WhatsApp conectando o seu próprio número.\n\nAssim o assistente responderá a pessoas que ainda não são clientes, tirando dúvidas sobre as suas acomodações e guiando-as até a reserva.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Escolha seu idioma · Choose your language",
    chatCheckinLink: "*Obrigado* 👋 Aqui está o seu link para fazer o Check-In. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Entrada",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nO seu código de acesso é: *58117*\n\nVálido durante toda a sua estadia.",
    lockNone: "🔑 *{label} · {name}*\n\nO cofre de chaves abre com o código: *{code}*\n\nDentro você encontrará as chaves da acomodação.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nO código da fechadura é: *{code}*\n\nUse-o para abrir a porta.",
    // Departure message (fallback)
    checkoutFallback: "Olá, *María* 👋\n\nApenas um lembrete de que sua estadia termina amanhã em *{name}*.\n\n🕚 O horário limite de check-out é *{time}*.\n\nMuito obrigado pela sua estadia. Boa viagem! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "Calendário iCal",
    heading: "Sincronização iCal",
    pageDesc: "Exporte suas reservas para outras plataformas e importe calendários externos para bloquear datas automaticamente no seu anúncio.",
    loading: "Carregando configuração…",
    exportLabel: "Seu link iCal (exportação)",
    exportDesc: "Copie este link e cole no Airbnb, Booking.com ou em qualquer plataforma que suporte sincronização iCal. Elas importarão suas reservas automaticamente.",
    copied: "Copiado",
    copy: "Copiar",
    tipAllUnits: "Este link inclui as reservas de <strong>todas as unidades</strong> do anúncio.",
    tipHotelRooms: "Cada <strong>quarto físico</strong> tem seu próprio link. Conecte-o no Airbnb/Booking para aquele quarto específico e somente as reservas DAQUELE quarto serão exportadas.",
    importLabel: "Calendários externos (importação)",
    syncing: "Sincronizando…",
    syncAll: "Sincronizar todos",
    importDesc: "Cole as URLs iCal das suas outras plataformas (Airbnb, Booking.com etc.) e a Wacheckin bloqueará essas datas automaticamente no seu calendário.",
    lastSync: "Última sincronização: {date}",
    delete: "Excluir",
    empty: "Você ainda não tem nenhum calendário externo vinculado.",
    addExternal: "Adicionar calendário externo",
    newExternal: "Novo calendário externo",
    nameLabel: "Nome do calendário",
    namePlaceholder: "ex.: Airbnb - Apt 1",
    physicalRoom: "Quarto físico",
    listingUnit: "Unidade do anúncio",
    selectRoomPlaceholder: "Selecione um quarto…",
    selectUnitPlaceholder: "Selecione uma unidade…",
    urlLabel: "URL do calendário iCal",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveSync: "Salvar e sincronizar",
    defaultGroup: "Quartos",
    toastLoadError: "Não foi possível carregar a configuração iCal.",
    toastSelectUnit: "Selecione um quarto / unidade.",
    toastAdded: "Calendário adicionado e sincronizado com sucesso.",
    toastAddError: "Erro ao adicionar o calendário.",
    deleteConfirm: 'Excluir "{name}" e todas as suas reservas bloqueadas?',
    toastDeleted: "Calendário excluído.",
    toastDeleteError: "Não foi possível excluir o calendário.",
    toastSyncError: "Erro ao sincronizar.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "Sincronização iCal",
    loading: "Carregando configuração…",
    exportLabel: "Seu link iCal (exportação)",
    exportDesc: "Copie este link e cole no Airbnb, Booking.com ou em qualquer plataforma que suporte sincronização iCal. Elas importarão suas reservas automaticamente.",
    copied: "Copiado",
    copy: "Copiar",
    tipAllUnits: "Este link inclui as reservas de <strong>todas as unidades</strong> do anúncio.",
    tipHotelRooms: "Cada <strong>quarto físico</strong> tem seu próprio link. Conecte-o no Airbnb/Booking para aquele quarto específico e somente as reservas DAQUELE quarto serão exportadas.",
    importLabel: "Calendários externos (importação)",
    syncing: "Sincronizando…",
    syncAll: "Sincronizar todos",
    importDesc: "Cole as URLs iCal das suas outras plataformas (Airbnb, Booking.com etc.) e a Wacheckin bloqueará essas datas automaticamente no seu calendário.",
    lastSync: "Última sincronização: {date}",
    delete: "Excluir",
    empty: "Você ainda não tem nenhum calendário externo vinculado.",
    addExternal: "Adicionar calendário externo",
    newExternal: "Novo calendário externo",
    nameLabel: "Nome do calendário",
    namePlaceholder: "ex.: Airbnb - Apt 1",
    physicalRoom: "Quarto físico",
    listingUnit: "Unidade do anúncio",
    selectRoomPlaceholder: "Selecione um quarto…",
    selectUnitPlaceholder: "Selecione uma unidade…",
    urlLabel: "URL do calendário iCal",
    cancel: "Cancelar",
    saveSync: "Salvar e sincronizar",
    defaultGroup: "Quartos",
    toastLoadError: "Não foi possível carregar a configuração iCal.",
    toastSelectUnit: "Selecione um quarto / unidade.",
    toastAdded: "Calendário adicionado e sincronizado com sucesso.",
    toastAddError: "Erro ao adicionar o calendário.",
    deleteConfirm: 'Excluir "{name}" e todas as suas reservas bloqueadas?',
    toastDeleted: "Calendário excluído.",
    toastDeleteError: "Não foi possível excluir o calendário.",
    toastSyncError: "Erro ao sincronizar.",
  },
};